var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.666,
    height: 8.777,
    viewBox: "0 0 11.666 8.777",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#33cdd1;stroke:#33cdd1;stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M102.31,60.522h0a.538.538,0,0,1-.413-.188l-2.834-3.078a.558.558,0,0,1,.826-.751l2.44,2.646,6.756-6.738a.544.544,0,0,1,.788,0,.561.561,0,0,1,0,.788L102.7,60.353A.511.511,0,0,1,102.31,60.522Z",
    transform: "translate(-98.919 -52.245)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.2675e08887b736a441b2111a90a52b24.svg";
export { ForwardRef as ReactComponent };